import { typeChecker } from '../commonJS/typeChecker';

// append all the key value pair from received obj
// if formDataObject is been passed in, it will be mutate.
export default function (obj, formDataObject) {
   if (typeChecker(obj) !== 'Object') return;

   if (!(formDataObject instanceof FormData)) {
      formDataObject = new FormData();
   }

   const keys = Object.keys(obj);

   for (let i = keys.length - 1; i >= 0; i--) {
      formDataObject.append(keys[i], obj[keys[i]]);
   }

   return formDataObject;
};


// WEBPACK FOOTER //
// ./src/helpers/formAppendMultiple.js